// Copyright 2017 Sorama B.V.

import { ISettingsKind } from "datatypes/SettingsKinds/ISettingsKind";
import { BandValue, OctaveBands } from "libraries/Math/OctaveBands";

export class FrequencyBandKind implements ISettingsKind {
    public name: string;
    public shortName: string;
    public icon: string;
    public toBands: (frequencyBandValues: BandValue[]) => BandValue[];
}

export const FrequencyBandKinds = {
    None: <FrequencyBandKind>{
        name: "None",
        shortName: "None",
        icon: "/resources/images/icons/Beamforming.svg",
        toBands: (frequencyBandValues) => frequencyBandValues,
    },
    Octave: <FrequencyBandKind>{
        name: "Octave",
        shortName: "1/1 OCT",
        icon: "/resources/images/icons/Beamforming.svg",
        toBands: (frequencyBandValues) => OctaveBands.toOctaveBands(frequencyBandValues),
    },
    OneThirdOctave: <FrequencyBandKind>{
        name: "One-Third Octave",
        shortName: "1/3 OCT",
        icon: "/resources/images/icons/Beamforming.svg",
        toBands: (frequencyBandValues) => OctaveBands.toOneThirdOctaveBands(frequencyBandValues),
    },
    All: function (): FrequencyBandKind[] {
        return [this.Octave, this.OneThirdOctave];
    },
};
